import React, { useEffect, useState } from "react";
import {
  addImages,
  addProduct,
  destoryCloud,
  getProduct,
  updateProduct,
} from "../../../../api/Products";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import SingleFileUpload from "../components/SingleFileUpload";
import MulitFileUpload from "../components/MulitFileUpload";
import { use } from "react";

const ArrayFormItem = ({ title, inputName, onChange, initialValues = [] }) => {
  const [value, setValue] = useState("");
  const [array, setArray] = useState(initialValues);

  useEffect(() => {
    setArray(initialValues);
  }, [initialValues]);

  const handleAddToArray = () => {
    if (value.trim()) {
      const updatedArray = [...array, value];
      setArray(updatedArray);
      setValue("");
      onChange(inputName, updatedArray);
    }
  };

  const handleDeleteFromArray = (indexToDelete) => {
    const updatedArray = array.filter((_, index) => index !== indexToDelete);
    setArray(updatedArray);
    onChange(inputName, updatedArray);
  };

  return (
    <div className="w-full mx-auto">
      <label
        htmlFor={inputName}
        className="block mb-2 text-sm font-medium text-gray-900"
      >
        {title}
      </label>
      <ul>
        {array.map((item, index) => (
          <li
            key={index}
            className="flex justify-between items-center bg-blue-800 text-white rounded px-5 py-2 mb-2"
          >
            {item}
            <button
              type="button"
              onClick={() => handleDeleteFromArray(index)}
              className="text-red-600 hover:text-red-900"
            >
              <i className="fa-solid fa-trash"></i>
            </button>
          </li>
        ))}
      </ul>
      <div className="flex w-full">
        <button
          type="button"
          onClick={handleAddToArray}
          className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-e-0 border-gray-300 rounded-s-md"
        >
          <i className="fa-solid fa-circle-plus"></i>
        </button>
        <input
          type="text"
          id={inputName}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="rounded-none rounded-e-lg bg-gray-50 border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm p-2.5"
          placeholder="Enter value"
        />
      </div>
    </div>
  );
};

const ArrayFieldOfApplication = ({ title, inputName, onChange, initialValues = [] ,options = [
    "General Imaging",
    "Obstetrics and Gynecology",
    "Cardiovascular",
    "Point of Care",
  ] }) => {
  const [array, setArray] = useState(initialValues);
  const [selected, setSelected] = useState("");


  useEffect(() => {
    setArray(initialValues);
  }, [initialValues]);

  const handleAddToArray = () => {
    if (selected && !array.includes(selected)) {
      const updatedArray = [...array, selected];
      setArray(updatedArray);
      setSelected("");
      onChange(inputName, updatedArray);
    }
  };

  const handleDeleteFromArray = (indexToDelete) => {
    const updatedArray = array.filter((_, index) => index !== indexToDelete);
    setArray(updatedArray);
    onChange(inputName, updatedArray);
  };

  return (
    <div className="w-full mx-auto">
      <label
        htmlFor={inputName}
        className="block mb-2 text-sm font-medium text-gray-900"
      >
        {title}
      </label>
      <ul>
        {array.map((item, index) => (
          <li
            key={index}
            className="flex justify-between items-center bg-blue-800 text-white rounded px-5 py-2 mb-2"
          >
            {item}
            <button
              type="button"
              onClick={() => handleDeleteFromArray(index)}
              className="text-red-600 hover:text-red-900"
            >
              <i className="fa-solid fa-trash"></i>
            </button>
          </li>
        ))}
      </ul>
      <div className="flex w-full">
        <select
          id={inputName}
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
          className="rounded-none rounded-e-lg bg-gray-50 border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm p-2.5"
        >
          <option value="">Select option</option>
          {options.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
        <button
          type="button"
          onClick={handleAddToArray}
          className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-e-0 border-gray-300 rounded-s-md"
        >
          <i className="fa-solid fa-circle-plus"></i>
        </button>
      </div>
    </div>
  );
};


const ImagesArray = ({ title, inputName, onChange, initialValues = [] }) => {
  const [value, setValue] = useState("");
  const [array, setArray] = useState(initialValues);
  const [loading, setLoading] = useState(false)
  // console.log(initialValues)
  useEffect(() => {
    setArray(initialValues);
  }, [initialValues]);

  const handleAddToArray = () => {
    if (value.trim()) {
      const updatedArray = [...array, value];
      setArray(updatedArray);
      setValue("");
      onChange(inputName, updatedArray);
    }
  };

  const handleDeleteFromArray = async(indexToDelete,public_id) => {
    try{
      const res = await destoryCloud(public_id)
      console.log(res)
      const updatedArray = array.filter((_, index) => index !== indexToDelete);
      setArray(updatedArray);
      onChange(inputName, updatedArray);
    }
    catch{
      console.log('error')
    }
  };

  return (
    <div className="w-full mx-auto">
      {array[0]?.url && (
        <label
          htmlFor={inputName}
          className="block mb-2 text-sm font-medium text-gray-900"
        >
          {title}
        </label>
      )}
      <div className="relative flex flex-wrap">
        {Array.isArray(array) &&
          array.length > 0 &&
          array[0]?.url &&
          array.map((item, index) => (
            <div
              key={index}
              className="flex flex-col justify-between items-center border text-white rounded px-5 py-2 mb-2"
            >
              <img src={item.url} className="w-20 h-20" />
              {array.length > 0 && (
                <button
                  type="button"
                  onClick={() => handleDeleteFromArray(index , item.public_id)}
                  className="w-20 h-20 absolute text-transparent hover:text-red-900"
                >
                  <i className="fa-solid fa-trash"></i>
                </button>
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

const SpecsArray = ({
  title,
  inputName,
  onChange,
  setMainSpec,
  initialValues = [],
  mainspecInitialValue = "",
}) => {
  const [specs, setSpecs] = useState(initialValues);
  const [currentSpec, setCurrentSpec] = useState("");
  const [currentChildKey, setCurrentChildKey] = useState("");
  const [currentChildValue, setCurrentChildValue] = useState("");

  useEffect(() => {
    setSpecs(initialValues);
  }, [initialValues]);

  const handleAddToSpecs = () => {
    if (currentSpec.trim()) {
      const newSpecs = [...specs, { [currentSpec]: [] }];
      setSpecs(newSpecs);
      setCurrentSpec("");
      onChange(inputName, newSpecs); // Notify parent of change
    }
  };

  const handleAddChildSpecs = (index, specKey) => {
    if (currentChildKey.trim() && currentChildValue.trim()) {
      const updatedSpecs = specs.map((spec, i) =>
        i === index
          ? {
              ...spec,
              [specKey]: [
                ...(spec[specKey] || []),
                { [currentChildKey]: currentChildValue },
              ],
            }
          : spec
      );
      setSpecs(updatedSpecs);
      setCurrentChildKey("");
      setCurrentChildValue("");
      onChange(inputName, updatedSpecs); // Notify parent of change
    }
  };

  const handleDeleteFromSpecs = (index) => {
    const updatedSpecs = specs.filter((_, i) => i !== index);
    setSpecs(updatedSpecs);
    onChange(inputName, updatedSpecs);
  };

  const handleDeleteChildSpecs = (specIndex, specKey, childIndex) => {
    const updatedSpecs = specs.map((spec, i) => {
      if (i === specIndex) {
        const updatedChildSpecs = spec[specKey].filter(
          (_, cIndex) => cIndex !== childIndex
        );
        return { ...spec, [specKey]: updatedChildSpecs };
      }
      return spec;
    });
    setSpecs(updatedSpecs);
    onChange(inputName, updatedSpecs);
  };

  return (
    <div className="w-full mx-auto">
      <label
        htmlFor="specs"
        className="block mb-2 text-sm font-medium text-gray-900"
      >
        {title}
      </label>
      <input
        type="text"
        value={mainspecInitialValue}
        onChange={(e) => setMainSpec("mainspec", e.target.value)}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 mb-4"
        placeholder="Enter main specification"
      />
      <ul>
        {specs.map((spec, index) => {
          const specKey = Object.keys(spec)[0];
          return (
            <li
              key={index}
              className="flex flex-col bg-blue-800 text-white rounded px-5 py-2 mb-2"
            >
              <div className="flex justify-between items-center mb-2">
                <span>{specKey}</span>
                <button
                  type="button"
                  onClick={() => handleDeleteFromSpecs(index)}
                  className="text-red-600 hover:text-red-900"
                >
                  <i className="fa-solid fa-trash"></i>
                </button>
              </div>
              {spec[specKey].length > 0 && (
                <ul className="ml-4">
                  {spec[specKey].map((child, childIndex) => {
                    const childKey = Object.keys(child)[0];
                    return (
                      <li
                        key={childIndex}
                        className="flex justify-between items-center bg-blue-600 text-white rounded px-5 py-1 mb-1"
                      >
                        {childKey}: {child[childKey]}
                        <button
                          type="button"
                          onClick={() =>
                            handleDeleteChildSpecs(index, specKey, childIndex)
                          }
                          className="text-red-600 hover:text-red-900"
                        >
                          <i className="fa-solid fa-trash"></i>
                        </button>
                      </li>
                    );
                  })}
                </ul>
              )}
              <div className="flex">
                <input
                  type="text"
                  value={currentChildKey}
                  onChange={(e) => setCurrentChildKey(e.target.value)}
                  className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm p-2.5"
                  placeholder="Child Key"
                />
                <input
                  type="text"
                  value={currentChildValue}
                  onChange={(e) => setCurrentChildValue(e.target.value)}
                  className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm p-2.5 ml-2"
                  placeholder="Child Value"
                />
                <button
                  type="button"
                  onClick={() => handleAddChildSpecs(index, specKey)}
                  className="ml-2 inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-gray-300 rounded-md hover:bg-gray-300"
                >
                  <i className="fa-solid fa-circle-plus mr-2"></i>
                  Add
                </button>
              </div>
            </li>
          );
        })}
      </ul>
      <div className="flex w-full mt-4">
        <input
          type="text"
          value={currentSpec}
          onChange={(e) => setCurrentSpec(e.target.value)}
          className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm p-2.5"
          placeholder="Enter specification"
        />
        <button
          type="button"
          onClick={handleAddToSpecs}
          className="ml-2 inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-gray-300 rounded-md hover:bg-gray-300"
        >
          <i className="fa-solid fa-circle-plus mr-2"></i>
          Add
        </button>
      </div>
    </div>
  );
};

const ArrayFileLink = ({
  itemTitle,
  inputName,
  onChange,
  initialValues = [],
}) => {
  const [title, setTitle] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [size, setSize] = useState("");
  const [array, setArray] = useState(initialValues);

  useEffect(() => {
    setArray(initialValues);
  }, [initialValues]);

  const handleAddToArray = () => {
    if (title.trim() && pdfUrl.trim() && size.trim()) {
      const newArray = [...array, { title, pdfUrl, size }];
      setArray(newArray);
      setTitle("");
      setPdfUrl("");
      setSize("");
      console.log(newArray)
      onChange(inputName, newArray); // Notify parent of change
    }
  };

  const handleDeleteFromArray = (indexToDelete) => {
    const newArray = array.filter((_, index) => index !== indexToDelete);
    setArray(newArray);
    onChange(inputName, newArray); // Notify parent of change
  };

  return (
    <div className="w-full mx-auto">
      <label
        htmlFor="fileLinks"
        className="block mb-2 text-sm font-medium text-gray-900"
      >
        {itemTitle}
      </label>
      <ul>
        {array.map((item, index) => (
          <li
            key={index}
            className="flex justify-between items-center bg-blue-800 text-white rounded px-5 py-2 mb-2"
          >
            {item.title} - {item.size}
            <button
              type="button"
              onClick={() => handleDeleteFromArray(index)}
              className="text-red-600 hover:text-red-900"
            >
              <i className="fa-solid fa-trash"></i>
            </button>
          </li>
        ))}
      </ul>
      <div className="flex w-full">
        <input
          type="text"
          onChange={(e) => setTitle(e.target.value)}
          className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm p-2.5"
          placeholder="Enter file name"
        />
        <input
          type="text"
          onChange={(e) => setPdfUrl(e.target.value)}
          className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm p-2.5 ml-2"
          placeholder="Enter file link"
        />
        <input
          type="text"
          onChange={(e) => setSize(e.target.value)}
          className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm p-2.5 ml-2"
          placeholder="Enter file size"
        />
        <button
          type="button"
          onClick={handleAddToArray}
          className="ml-2 inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-gray-300 rounded-md hover:bg-gray-300"
        >
          <i className="fa-solid fa-circle-plus mr-2"></i>
          Add
        </button>
      </div>
    </div>
  );
};

const EditProduct = () => {
  const [formData, setFormData] = useState({
    name: "",
    subname: "",
    description: "",
    benifits: [],
    features: [],
    pros: [],
    clinicalSegments: [],
    fields: [],
    mainspec: "",
    specs: [],
    fileLinks: [],
  });

  const [images, setImages] = useState([]);
  const [postLoading, setPostLoading] = useState(false);

  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const Navigate = useNavigate();
  useEffect(() => {
    const fetchProductData = async () => {
      setLoading(true);
      try {
        const data = await getProduct(id);
        console.log(data.data);
        const [firstImage, ...restOfImages] = data.data.images;
        setFormData({
          name: data.data.name || "",
          subname: data.data.subName || "",
          description: data.data.description.describe || "",
          benifits: data.data.description.benefits || [],
          features: data.data.feature || [],
          activeImage: [firstImage] || "",
          images: restOfImages || [],
          pros: data.data.pros || [],
          clinicalSegments: data.data.clinicalSegments.segments || [],
          fields: data.data.clinicalSegments.fieldOfApplication || [],
          mainspec: data.data.specifications[0].mainSpec || "",
          specs: data.data.specifications[1].specs || [],
          fileLinks: data.data.document || [],
        });

        console.log(firstImage);
      } catch (error) {
        console.error("Failed to fetch product data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProductData();
  }, [id]);

  const handleArrayChange = (key, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // console.log("Form Data:", formData);

    const requistHandle = {
      name: formData.name,
      subName: formData.subname,
      description: {
        describe: formData.description,
        benefits: formData.benifits,
      },
      feature: formData.features,
      pros: formData.pros,
      clinicalSegments: {
        segments: formData.clinicalSegments,
        fieldOfApplication: formData.fields,
      },
      document: formData.fileLinks.map(({ _id, ...rest }) => rest),
      specifications: [
        { mainSpec: formData.mainspec },
        { specs: formData.specs },
      ],
    };
    console.log(requistHandle);

    // setLoading(true);
    // console.log("requist")
    setPostLoading(true);
    const res = await updateProduct(requistHandle, id);
    console.log(res);
    Navigate("/dashboard/main/product");
    setPostLoading(false);
  };

  return (
    <>
      {loading ? (
        <div className="flex h-full items-center justify-center">
          {" "}
          <LoadingSpinner />{" "}
        </div>
      ) : (
        <>
          <h3 className="mx-auto p-5">Edit Product Form</h3>
          <hr className="my-5" />

          <form className="max-w-full mx-auto" onSubmit={handleSubmit}>
            <div className="flex md:flex-row flex-col items-start justify-between w-full ">
              <div className="flex flex-col items-start justify-center p-5 w-full md:w-3/5">
                <div className="flex md:flex-row flex-col items-start gap-4 w-full">
                  <div className="w-full">
                    <label
                      htmlFor="name"
                      className="block mb-2 text-sm font-medium text-gray-900"
                    >
                      Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      value={formData.name}
                      onChange={(e) =>
                        handleArrayChange("name", e.target.value)
                      }
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                      placeholder="Product name"
                    />
                  </div>
                  <div className="w-full">
                    <label
                      htmlFor="subname"
                      className="block mb-2 text-sm font-medium text-gray-900"
                    >
                      Sub-name
                    </label>
                    <input
                      type="text"
                      id="subname"
                      value={formData.subname}
                      onChange={(e) =>
                        handleArrayChange("subname", e.target.value)
                      }
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                      placeholder="Product sub name"
                    />
                  </div>
                </div>
                <div className="w-full mt-5">
                  <label
                    htmlFor="description"
                    className="block mb-2 text-sm font-medium text-gray-900"
                  >
                    Description
                  </label>
                  <textarea
                    id="description"
                    rows="4"
                    value={formData.description}
                    onChange={(e) =>
                      handleArrayChange("description", e.target.value)
                    }
                    className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Product Description"
                  ></textarea>
                </div>
                <div className=" w-full mt-5">
                  <SingleFileUpload setImages={setImages} />
                  <br />
                  <ImagesArray
                    inputName={"mainImage"}
                    title={"main image"}
                    initialValues={formData.activeImage}
                    onChange={handleArrayChange}
                  />

                  <br />
                  <MulitFileUpload setImages={setImages} />
                  <br />
                  <ImagesArray
                    inputName={"images"}
                    title={"images"}
                    initialValues={formData.images}
                    onChange={handleArrayChange}
                  />
                  {/* <p onClick={()=>{console.log(formData.images)}}>data</p> */}
                </div>
              </div>
              <div className="flex md:w-2/5 w-full p-5 bg-gray-100">
                <div className="w-full">
                  <ArrayFormItem
                    title={"Benefits"}
                    inputName={"benifits"}
                    onChange={handleArrayChange}
                    initialValues={formData.benifits}
                  />
                </div>
              </div>
            </div>

            <hr className="my-5" />

            <div className="flex md:flex-row flex-col items-start justify-between w-full ">
              <div className="flex md:w-1/2 w-full p-5">
                <div className="w-full">
                  <ArrayFormItem
                    title={"Features"}
                    inputName={"features"}
                    onChange={handleArrayChange}
                    initialValues={formData.features}
                  />
                </div>
              </div>

              <div className="flex md:w-1/2 w-full p-5 ">
                <div className="w-full">
                  <ArrayFormItem
                    title={"Pros"}
                    inputName={"pros"}
                    onChange={handleArrayChange}
                    initialValues={formData.pros}
                  />
                </div>
              </div>
            </div>

            <hr className="my-5" />

            <div className="flex md:flex-row flex-col items-start justify-between w-full ">
              <div className="flex md:w-1/2 w-full p-5">
                <div className="w-full">
                  <ArrayFormItem
                    title={"Clinical Segments"}
                    inputName={"clinicalSegments"}
                    onChange={handleArrayChange}
                    initialValues={formData.clinicalSegments}
                  />
                </div>
              </div>

              <div className="flex md:w-1/2 w-full p-5 ">
                <div className="w-full">
                  {/* <ArrayFormItem
                    title={"Field Of Application"}
                    inputName={"fields"}
                    onChange={handleArrayChange}
                    initialValues={formData.fields}
                  /> */}
                  <ArrayFieldOfApplication
                    title={"Field Of Application"}
                    inputName={"fields"}
                    onChange={handleArrayChange}
                    initialValues={formData.fields}
                  />
                </div>
              </div>
            </div>

            <hr className="my-5" />

            <ArrayFileLink
              title={"Documents"}
              inputName={"fileLinks"}
              onChange={handleArrayChange}
              initialValues={formData.fileLinks}
            />
            <hr className="my-5" />
            <SpecsArray
              mainspecInitialValue={formData.mainspec}
              title={"Specifications"}
              onChange={handleArrayChange}
              inputName={"specs"}
              setMainSpec={handleArrayChange}
              initialValues={formData.specs}
            />
            <hr className="my-5" />

            <div className="flex justify-end">
              {/* <input type="submit" value={"update product"} class="text-white w-full bg-gradient-to-r from-cyan-500 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"/> */}
              {postLoading ? (
                <button className="text-white w-full bg-gradient-to-r from-cyan-500 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">
                  <LoadingSpinner />
                </button>
              ) : (
                <input
                  type="submit"
                  value={"update product"}
                  className="text-white w-full bg-gradient-to-r from-cyan-500 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
                />
              )}
            </div>
          </form>
        </>
      )}
    </>
  );
};

export default EditProduct;
